import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2139de6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thumbnails" }
const _hoisted_2 = ["src", "onClick"]

import { computed, ref, toRefs } from 'vue'
    import ImageGallery from '@/components/ui/ImageGallery.vue'
    import IconGrid from '@/components/icons/IconGrid.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    images: null
  },
  setup(__props: any) {

const props = __props as { images: string[] }

    
    const imageIndex = ref<number|null>(null)

    const thumbnails = computed(() => {
        if (!images.value) {
            return []
        }

        return images.value?.slice(0, images.value?.length > 5 ? 5 : undefined)
    })

    const openGallery = (index: number) => {
        imageIndex.value = index
    }

    const { images } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(thumbnails), (src, index) => {
      return (_openBlock(), _createElementBlock("img", {
        key: index,
        src: src,
        onClick: ($event: any) => (openGallery(index))
      }, null, 8, _hoisted_2))
    }), 128)),
    _createElementVNode("div", {
      class: "thumbnails__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openGallery(0)))
    }, [
      _createVNode(IconGrid, { size: 18 }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('viewing.thumbnails.open-gallery')), 1)
    ]),
    _createVNode(ImageGallery, {
      imageIndex: imageIndex.value,
      onHide: _cache[1] || (_cache[1] = ($event: any) => (imageIndex.value = null)),
      images: _unref(images)
    }, null, 8, ["imageIndex", "images"])
  ]))
}
}

})